import { render, staticRenderFns } from "./BrandTypographyPicker.vue?vue&type=template&id=8fc44516&"
import script from "./BrandTypographyPicker.vue?vue&type=script&lang=ts&"
export * from "./BrandTypographyPicker.vue?vue&type=script&lang=ts&"
import style0 from "./BrandTypographyPicker.vue?vue&type=style&index=0&id=8fc44516&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports